import { axiosGet, axiosPost } from "./axiosService";
const url = "/payload";

export const getPayload = (param) => axiosGet(url, param);
export const postDownloadPayload = (body) => axiosPost(`${url}/download`, body);
